import React from 'react';

import './styles.scoped.css';

const Tile = ({ icon, text, onPress, disabled }) => {
  return (
    <div
      className={`tile${disabled ? ' tile--disabled' : ''}`}
      onClick={() => !disabled && onPress()}
    >
      {icon}
      <span className="tile-text">{text}</span>
    </div>
  );
};

export default Tile;
